import { useIsMobile } from '@cleartax/wg-library-hooks';
import { TSearchResultFull } from '../../../../../../../pages/services/[planSeoSlug]/api/types';
import { trackAction } from '../../../../../../utils';
import { findSearchDocumentWithName } from '../utils';
import { DekstopCustomSearchResult } from './desktop';
import { MobileCustomSearchResult } from './mobile';

interface ICustomSearchResult {
  searchItems: TSearchResultFull | undefined;
  name: string;
}
export const CustomSearchResult: React.FC<ICustomSearchResult> = ({
  searchItems,
  name,
}) => {
  //TODO: Currently this find is O(n) and we loop over search items so our complexity is O(n^2)
  // Need to optimise, we can allow for now as array length is 10 so hence it will be O(1)
  const currentOption = findSearchDocumentWithName(searchItems, name);
  const isMobile = useIsMobile();
  if (!currentOption) return <></>;
  return (
    <div
      onClick={() =>
        trackAction('click', '', {
          label: `search_result_${currentOption.document.seo_slug}`,
        })
      }
    >
      {isMobile ? (
        <MobileCustomSearchResult
          searchItem={currentOption.document}
          seachHighlights={currentOption.highlights}
        />
      ) : (
        <DekstopCustomSearchResult
          searchItem={currentOption.document}
          seachHighlights={currentOption.highlights}
        />
      )}
    </div>
  );
};
